<template>
  <div :class="className">
    <div class="at-eg">
      <div class="at-eg-hd" id="at-eg-hd">
        <table cellpadding="0" cellspacing="0" border="0" class="at-eg-tb">
          <thead>
            <tr>
              <th v-for="date in dates">{{ date.substring(5,date.length) }}</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="at-eg-bd" @scroll="hdScroll" id="table">
        <table class="at-eg-tb at-eg-tasks">
          <tbody>
            <user-tasks
              v-for="(obj, idx) in egtasks"
              :user="obj.user"
              :tasks="obj.tasks"
              :childHeight="childHeight"
              :dates="dates"
              :cls="idx % 2 === 0 ? 'at-eg-odd' : ''"
            ></user-tasks>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<!--.at-eg-tgroup{-->
<!--min-height: 36px !important;-->
<!--height: 36px !important;-->
<!--}-->
<style lang="stylus" src="./styles/style.styl"></style>
<style>
.not-data {
  height: 360px;
  justify-content: center;
  font-size: 22px;
  color: #e4e4e4;
}
#at-eg-hd::-webkit-scrollbar {
  display: none;
}
#at-eg-hd {
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
}
#at-eg-hd {
  border-bottom: 1px solid #e4e4e4;
}
</style>
<script>
import UserTasks from "./UserTasks.vue";
import UserTaskParser from "./UserTaskParser";
export default {
  data() {
    return {
      dates: [],
      isLoading: false,
      scrollRange: 0
    };
  },
  methods: {
    hdScroll(e) {
      // this.scrollRange = e.target.scrollLeft
      document.getElementById("at-eg-hd").scrollLeft = e.target.scrollLeft;
      console.log(e.target.scrollLeft);
    },
    scrollLeft() {
      //定位到今天
      let num = 50;
      let time = new Date();
      let y = time.getFullYear();
      let m =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      let d = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
      let ymd = y + "-" + m + "-" + d;
      for (let i = 0; i < this.dates.length; i++) {
        if (this.dates[i] == ymd) {
          console.log(this.dates[i], ymd,this.dates);
          num *= i;
        }
      }
      if (num > 50) {
        this.$nextTick(() => {
          document.getElementById("table").scrollLeft = num;
        });
      }
    }
  },
  props: {
    childHeight: {},
    utasks: {
      type: Array,
      default: []
    },
    sdate: String,
    spinner: {
      type: String,
      default: "default"
    },
    startTime: {
      type: String,
      default: "2019-01-01"
    },
    endTime: {
      type: String,
      default: "2019-11-01"
    },
    className: String
  },
  computed: {
    egtasks() {
      let items = [];
      let self = this;
      this.utasks.forEach((obj, idx) => {
        let utp = new UserTaskParser(
          obj.tasks,
          this.sdate,
          this.startTime,
          this.endTime
        );
        let data = {};
        data.user = obj;
        data.tasks = utp.items;
        data.total = utp.total;
        self.dates = utp.dates;
        console.log(utp, 11111);
        items.push(data);
      });
      return items;
    }
  },
  components: {
    UserTasks
  },
  created() {
    this.isLoading = true;
  },
  updated() {
    this.isLoading = false;
  },
  mounted() {
    this.scrollLeft();
  }
};
</script>
